module.exports = __webpack_public_path__ + "static/media/fundrisescreenshot.02380fbc.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/images/fundrisescreenshot.png
 ** module id = 430
 ** module chunks = 0
 **/